<template>
    <div>
        <h1 class="title is-5" style="text-align:center;font-weight:bold;">ログイン</h1>
        <div id="firebaseui-auth-container"></div>
        <div style="text-align:center;">
            <p>以下の事項を確認し了承いただき、会員登録をしてください。</p>
            <h3>アカウント連携について</h3>
            <p>連携許可をログイン以外の目的で使用することはありません。</p>
            <h3>禁止行為</h3>
            <ul>
                <li>・相手への尊敬を欠いた失礼なコメント</li>
                <li>・人のテンションを下げるような発言・誹謗中傷</li>
                <li>・R-18のエロい絵・グロテスクな絵の投稿</li>
                <li>・本サイトにアップロードされている投稿作品の情報を、当該著作者（創作者）の同意なくして転載する行為</li>
            </ul>
        </div>
        <hr>
    </div>
</template>
<script>
var firebase = require("firebase");
var firebaseui = require("firebaseui-ja");
require("firebaseui-ja/dist/firebaseui.css");
export default {
    mounted() {
        const title = "ログイン｜イラスト頑張るクラブ"
        const description = "イラスト頑張るクラブのログイン画面です。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
        let uiConfig = {
            callbacks: {
                signInSuccess: function(user) {
                    firebase.firestore().collection('user').doc(user.uid).set({
                        uid: user.uid,
                        creationTime: user.metadata.creationTime
                    },{ merge: true }).then(()=>{
                        window.location.href = '/';
                    });
                }
            },
            signInOptions: [
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                firebase.auth.TwitterAuthProvider.PROVIDER_ID,
                {
                    provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                    signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
                    forceSameDevice: false
                }
            ],
            // signInSuccessUrl: 'https://translate.ameneko.com/home',
        }
        var ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())
        ui.start("#firebaseui-auth-container", uiConfig)
    }

}
</script>
<style scoped>
h3{
    font-size: 1.2em;
    font-weight: bold;
    text-align:center;
    margin:20px 0 20px 0;
}
li{
    font-size: 1em;
}
.login_info{
    margin: 50px 20px 50px 20px;
}

</style>